<template>
  <div>
    <div class="invite-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1 class="banner-title">加入我们</h1>
        <p class="banner-subtitle">与优秀的人一起，用技术赋能中小银行智能升级</p>
      </div>
    </div>
    <div class="navbar">
      <el-menu :default-active="activeName" mode="horizontal" @select="selectMenu">
        <el-menu-item index="java"><span class="menu-icon">&#x1F4BB;</span>JavaWeb工程师</el-menu-item>
        <el-menu-item index="man"><span class="menu-icon">&#x1F4CB;</span>项目经理</el-menu-item>
        <el-menu-item index="data"><span class="menu-icon">&#x1F4CA;</span>数据实施工程师</el-menu-item>
        <el-menu-item index="etl"><span class="menu-icon">&#x1F504;</span>ETL工程师</el-menu-item>
        <el-menu-item index="sale"><span class="menu-icon">&#x1F91D;</span>销售经理</el-menu-item>
      </el-menu>
    </div>
    <div class="container">
      <div v-show="activeName == 'java'" class="job-detail">
        <div class="job-header">
          <h2 class="job-title">JavaWeb工程师</h2>
          <div class="job-tags">
            <span class="job-tag">全职</span>
            <span class="job-tag">技术研发</span>
          </div>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F4CC;</span>
            <h3>岗位要求</h3>
          </div>
          <ul class="req-list">
            <li>JAVA 基础扎实，理解 io、多线程、集合等基础框架，对 JVM 原理有一定的了解</li>
            <li>有一定的数据结构基础，理解基础的一些算法</li>
            <li>熟练掌握 Servlet 原理，JSP 相关技术，理解 tomcat 运行原理</li>
            <li>掌握Spring、SpringMVC、SpringBoot等开源框架，可以熟练使用其配置及调优</li>
            <li>熟悉HTML5、CSS3、Javascript 基础前端技术</li>
            <li>了解JDBC原理，可以熟练使用一种或多种持久层框架（MyBatis、MyBatisPlus等）</li>
            <li>能够正常使用一种或多种数据库（MySql，DB2，Oracle 等）</li>
            <li>了解一些常用的中间件，如 nginx、redis 等</li>
            <li>具备良好的自学能力，能够在短时间内完成对业务需要的补充</li>
            <li>具备良好的沟通能力及团队合作精神，能够承受一定的工作压力</li>
          </ul>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F3AF;</span>
            <h3>岗位职责</h3>
          </div>
          <ul class="req-list">
            <li>负责公司产品的功能规划、需求分析设计、技术实现</li>
            <li>负责所属模块的代码开发、调试与维护工作</li>
            <li>积极响应客户需求并进行开发/定制化开发和交付</li>
            <li>参与公司产品的架构优化，性能优化并辅助其他模块进行技术实现</li>
            <li>负责相关文档的编写（如接口文档、用户手册等）</li>
          </ul>
        </div>
      </div>
      <div v-show="activeName == 'man'" class="job-detail">
        <div class="job-header">
          <h2 class="job-title">项目经理</h2>
          <div class="job-tags">
            <span class="job-tag">全职</span>
            <span class="job-tag">项目管理</span>
          </div>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F4CC;</span>
            <h3>岗位要求</h3>
          </div>
          <ul class="req-list">
            <li>熟悉银行业务</li>
            <li>有负责过银行相关管理系统经验，如绩效考核系统、数据仓库、报表系统、数据可视化、网格化管理、CRM系统、管理会计系统、客户积分系统等</li>
            <li>精通一种或多种数据库（DB2，Oracle，Mysql）</li>
            <li>了解数据库的体系结构，基础扎实，熟练各部分的管理</li>
            <li>掌握数据库的存储过程，函数语法</li>
            <li>懂得对数据库性能分析优化，对数据库进行日常维护及性能监控和调优</li>
            <li>熟悉 linux 操作系统，熟练shell脚本开发</li>
            <li>熟悉ETL架构，熟练使用一种或多种ETL工具（如kettle、informatica、datastage），有丰富的ETL、数据处理相关开发经验</li>
          </ul>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F3AF;</span>
            <h3>岗位职责</h3>
          </div>
          <ul class="req-list">
            <li>负责银行管理系统项目交付，如绩效考核系统、数据仓库、报表系统、数据可视化、客户管理系统、管理会计系统、客户积分系统等</li>
            <li>推进项目验收、项目回款</li>
            <li>敏锐洞察客户需求，协助产品销售</li>
          </ul>
        </div>
      </div>
      <div v-show="activeName == 'data'" class="job-detail">
        <div class="job-header">
          <h2 class="job-title">数据实施工程师</h2>
          <div class="job-tags">
            <span class="job-tag">全职</span>
            <span class="job-tag">数据实施</span>
          </div>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F4CC;</span>
            <h3>岗位要求</h3>
          </div>
          <ul class="req-list">
            <li>精通一种或多种数据库（DB2，Oracle，Mysql）</li>
            <li>了解数据库的体系结构，基础扎实，熟练各部分的管理</li>
            <li>掌握数据库的存储过程，函数语法</li>
            <li>懂得对数据库性能分析优化，对数据库进行日常维护及性能监控和调优</li>
            <li>熟悉 linux 操作系统，熟练shell脚本开发</li>
            <li>熟悉ETL架构，熟练使用一种或多种ETL工具（如kettle、informatica、datastage），有丰富的ETL、数据处理相关开发经验</li>
            <li>懂银行业务优先</li>
            <li>有银行相关系统实施经验优先，如绩效考核系统、数据仓库、报表系统、数据可视化、网格化管理、CRM系统、管理会计系统、客户积分系统等</li>
          </ul>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F3AF;</span>
            <h3>岗位职责</h3>
          </div>
          <ul class="req-list">
            <li>负责数据库存储过程、函数的开发</li>
            <li>负责数据仓库、客户管理、绩效系统等数据项目实施</li>
            <li>负责项目数据库的部署、维护与监控</li>
            <li>负责项目数据库优化工作（参数调整，性能分析等）</li>
            <li>负责ETL架构设计、流程设计、ETL映射编写</li>
            <li>根据业务需求及数据仓库模型进行ETL开发</li>
          </ul>
        </div>
      </div>
      <div v-show="activeName == 'etl'" class="job-detail">
        <div class="job-header">
          <h2 class="job-title">ETL工程师</h2>
          <div class="job-tags">
            <span class="job-tag">全职</span>
            <span class="job-tag">数据开发</span>
          </div>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F4CC;</span>
            <h3>岗位要求</h3>
          </div>
          <ul class="req-list">
            <li>精通一种或多种数据库（DB2，Oracle，Mysql）</li>
            <li>了解数据库的体系结构，基础扎实，熟练各部分的管理</li>
            <li>掌握数据库的存储过程，函数语法</li>
            <li>懂得对数据库性能分析优化，对数据库进行日常维护及性能监控和调优</li>
            <li>熟悉 linux 操作系统，熟练shell脚本开发</li>
            <li>熟悉ETL架构，熟练使用一种或多种ETL工具（如kettle、informatica、datastage），有丰富的ETL、数据处理相关开发经验</li>
            <li>懂银行业务优先</li>
            <li>有银行相关系统实施经验优先，如绩效考核系统、数据仓库、报表系统、数据可视化、网格化管理、CRM系统、管理会计系统、客户积分系统等</li>
          </ul>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F3AF;</span>
            <h3>岗位职责</h3>
          </div>
          <ul class="req-list">
            <li>负责数据库存储过程、函数的开发</li>
            <li>负责数据仓库、客户管理、绩效系统等数据项目实施</li>
            <li>负责项目数据库的部署、维护与监控</li>
            <li>负责项目数据库优化工作（参数调整，性能分析等）</li>
            <li>负责ETL架构设计、流程设计、ETL映射编写</li>
            <li>根据业务需求及数据仓库模型进行ETL开发</li>
          </ul>
        </div>
      </div>
      <div v-show="activeName == 'sale'" class="job-detail">
        <div class="job-header">
          <h2 class="job-title">销售经理</h2>
          <div class="job-tags">
            <span class="job-tag">全职</span>
            <span class="job-tag">市场销售</span>
          </div>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F4CC;</span>
            <h3>岗位要求</h3>
          </div>
          <ul class="req-list">
            <li>计算机、市场营销等相关专业优先考虑</li>
            <li>有良好的沟通能力及市场开拓能力</li>
            <li>有较强的个人魅力及人际协调能力</li>
            <li>具有勇于挑战的精神及敢于担当的能力</li>
            <li>有银行软件、咨询、培训等业务销售经验优先</li>
          </ul>
        </div>
        <div class="req-section">
          <div class="req-header">
            <span class="req-icon">&#x1F3AF;</span>
            <h3>岗位职责</h3>
          </div>
          <ul class="req-list">
            <li>根据公司提供的精准客户传达产品宣传、推广和销售</li>
            <li>负责开发新客户，开拓市场</li>
            <li>维护客户关系，定期回访，促进产品销售</li>
            <li>调研客户需求</li>
            <li>商务谈判</li>
            <li>签订商务合同</li>
            <li>跟进回款</li>
            <li>客户回访及满意度调查</li>
          </ul>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="contact-section">
        <h2 class="contact-title">简历投递</h2>
        <p class="contact-desc">期待优秀的你加入我们，一起成长</p>
        <div class="contact-cards">
          <div class="contact-card">
            <span class="contact-icon">&#x1F464;</span>
            <div class="contact-info">
              <span class="contact-label">联系人</span>
              <span class="contact-value">郭老师</span>
            </div>
          </div>
          <div class="contact-card">
            <span class="contact-icon">&#x1F4DE;</span>
            <div class="contact-info">
              <span class="contact-label">联系电话</span>
              <span class="contact-value">15710118988</span>
            </div>
          </div>
          <div class="contact-card">
            <span class="contact-icon">&#x1F4E7;</span>
            <div class="contact-info">
              <span class="contact-label">电子邮箱</span>
              <span class="contact-value">linfeng_guo@163.com</span>
            </div>
          </div>
          <div class="contact-card">
            <span class="contact-icon">&#x1F4CD;</span>
            <div class="contact-info">
              <span class="contact-label">联系地址</span>
              <span class="contact-value">上海市青浦区徐泾镇徐详路368号8090青创基地4009室</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeName: 'java',
        head_invite: require('@/assets/head_invite.jpg')
      };
    },
    methods: {
      selectMenu(index) {
        this.activeName = index
      }
    }
  };
</script>

<style lang="less" scoped>
  
  .invite-banner {
    position: relative;
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #0d1421 0%, #151d2e 40%, #1e3252 100%);
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background:
        radial-gradient(ellipse at 20% 50%, rgba(47, 125, 205, 0.15) 0%, transparent 60%),
        radial-gradient(ellipse at 80% 50%, rgba(255, 208, 75, 0.08) 0%, transparent 50%);
    }

    .banner-content {
      text-align: center;
      z-index: 1;
      animation: fadeInUp 0.8s ease;
    }

    .banner-title {
      font-size: 42px;
      font-weight: 700;
      color: #fff;
      margin: 0 0 16px;
      letter-spacing: 4px;
    }

    .banner-subtitle {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.65);
      margin: 0;
      letter-spacing: 1px;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(24px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .navbar {
    padding: 12px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    background: linear-gradient(135deg, #0d1421 0%, #151d2e 40%, #1a2438 100%);
    box-shadow: 0 4px 28px rgba(0, 0, 0, 0.25);
    position: sticky;
    top: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    .el-menu {
      background: transparent;
    }

    .el-menu-item {
      padding: 10px 22px;
      color: rgba(255, 255, 255, 0.78);
      font-size: 14px;
      font-weight: 500;
      border-radius: 24px;
      height: auto;
      line-height: 1.4;
      margin: 0 5px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      align-items: center;
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid transparent;
    }

    .menu-icon {
      font-size: 15px;
      margin-right: 6px;
      flex-shrink: 0;
      transition: transform 0.3s ease;
    }

    .el-menu-item:hover {
      color: #fff;
      background: rgba(255, 255, 255, 0.12);
      border-color: rgba(255, 255, 255, 0.15);
      transform: translateY(-1px);

      .menu-icon {
        transform: scale(1.12);
      }
    }

    .el-menu-item.is-active {
      color: #ffd04b;
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 208, 75, 0.3);
      transform: translateY(-1px);
      font-weight: 600;

      .menu-icon {
        transform: scale(1.12);
      }
    }
  }

  .container {
    max-width: 900px;
    margin: 0 auto;
    padding: 48px 40px 60px;

    .el-divider {
      margin: 60px 0 48px;
      background: linear-gradient(90deg, transparent, rgba(13, 20, 33, 0.12), transparent);
      height: 1px;
    }
  }

  .job-detail {
    animation: fadeInUp 0.4s ease;
  }

  .job-header {
    text-align: center;
    margin-bottom: 40px;

    .job-title {
      font-size: 30px;
      font-weight: 700;
      color: #1a2844;
      margin: 0 0 14px;
    }

    .job-tags {
      display: flex;
      justify-content: center;
      gap: 10px;
    }

    .job-tag {
      display: inline-flex;
      align-items: center;
      padding: 5px 16px;
      font-size: 13px;
      color: #1a56b8;
      background: rgba(26, 86, 184, 0.08);
      border-radius: 20px;
      border: 1px solid rgba(26, 86, 184, 0.12);
    }
  }

  .req-section {
    margin-bottom: 36px;

    .req-header {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding-bottom: 12px;
      border-bottom: 1px solid rgba(13, 20, 33, 0.06);

      .req-icon {
        font-size: 20px;
        margin-right: 10px;
      }

      h3 {
        font-size: 20px;
        font-weight: 700;
        color: #1a2844;
        margin: 0;
      }
    }
  }

  .req-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 10px;

    li {
      position: relative;
      padding: 14px 16px 14px 42px;
      font-size: 14px;
      color: #3a3b3c;
      line-height: 1.7;
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
      border-radius: 10px;
      border: 1px solid rgba(26, 86, 184, 0.06);
      transition: all 0.25s ease;
      counter-increment: req-count;

      &::before {
        content: counter(req-count);
        position: absolute;
        left: 12px;
        top: 14px;
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 600;
        color: #1a56b8;
        background: rgba(26, 86, 184, 0.08);
        border-radius: 6px;
        flex-shrink: 0;
      }

      &:hover {
        background: #fff;
        border-color: rgba(26, 86, 184, 0.15);
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
        transform: translateX(2px);

        &::before {
          background: #1a56b8;
          color: #fff;
        }
      }
    }
  }

  .req-section {
    counter-reset: req-count;
  }

  .contact-section {
    text-align: center;

    .contact-title {
      font-size: 28px;
      font-weight: 700;
      color: #1a2844;
      margin: 0 0 10px;
    }

    .contact-desc {
      font-size: 15px;
      color: #888;
      margin: 0 0 40px;
    }

    .contact-cards {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 20px;
    }

    .contact-card {
      display: flex;
      align-items: flex-start;
      padding: 24px 20px;
      background: #fff;
      border-radius: 14px;
      border: 1px solid rgba(13, 20, 33, 0.06);
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
      }

      .contact-icon {
        font-size: 28px;
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f0f4f8 0%, #e8edf3 100%);
        border-radius: 12px;
        margin-right: 14px;
        flex-shrink: 0;
      }

      .contact-info {
        display: flex;
        flex-direction: column;
        text-align: left;
        min-width: 0;

        .contact-label {
          font-size: 12px;
          color: #999;
          margin-bottom: 4px;
        }

        .contact-value {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          word-break: break-all;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .invite-banner {
      height: 200px;

      .banner-title {
        font-size: 28px;
        letter-spacing: 2px;
      }

      .banner-subtitle {
        font-size: 14px;
      }
    }

    .navbar {
      padding: 8px 10px;
      overflow-x: auto;
      justify-content: flex-start;

      .el-menu {
        display: flex;
        flex-wrap: nowrap;
      }

      .el-menu-item {
        padding: 7px 12px;
        font-size: 12px;
        margin: 0 3px;
        white-space: nowrap;
        border-radius: 18px;
      }

      .menu-icon {
        font-size: 12px;
        margin-right: 3px;
      }
    }

    .container {
      padding: 28px 18px 40px;
    }

    .job-header .job-title {
      font-size: 24px;
    }

    .req-list {
      grid-template-columns: 1fr;
      gap: 8px;

      li {
        padding: 12px 14px 12px 36px;
        font-size: 13px;

        &::before {
          left: 10px;
          top: 12px;
          width: 20px;
          height: 20px;
          font-size: 10px;
        }
      }
    }

    .contact-cards {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
</style>